import { useState } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import {
  FinancialPlanQualityPillar,
  FinancialPlanRequirements,
  FinancialPlanScoreInfo,
  IFinancialPlanQuality,
} from 'partner360/features/financialPlanQuality'
import { TRANSLATION_KEYS } from 'partner360/features/financialPlanQuality/configs/translations'

import { PlanReviewSection } from '../model/types'

interface IFinancialQualityStepProps {
  section: PlanReviewSection.FinancialGrowth | PlanReviewSection.SobGrowth
  quality: IFinancialPlanQuality
  hasPlan: boolean
}

export const FinancialQualityStep = ({ section, quality, hasPlan }: IFinancialQualityStepProps) => {
  const [isScoreInfoVisible, setIsScoreInfoVisible] = useState(false)
  const config =
    section === PlanReviewSection.FinancialGrowth
      ? {
          title: TRANSLATION_KEYS.quality.financialGrowth.title,
          description: TRANSLATION_KEYS.quality.financialGrowth.description,
          pillar: quality.financialGrowth,
        }
      : {
          title: TRANSLATION_KEYS.quality.sobGrowth.title,
          description: TRANSLATION_KEYS.quality.sobGrowth.description,
          pillar: quality.sobGrowth,
        }

  if (!hasPlan) {
    return <FinancialPlanRequirements />
  }

  return (
    <>
      <FinancialPlanQualityPillar
        title={config.title}
        description={config.description}
        pillar={config.pillar}
        onHowScore={() => setIsScoreInfoVisible(true)}
        isPlanningOpenInNewTab
        initialDetailsOpen
      />

      <ModalDialog
        show={isScoreInfoVisible}
        onClose={() => setIsScoreInfoVisible(false)}
        content={() => <FinancialPlanScoreInfo />}
        size="xs"
      />
    </>
  )
}
